import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "searchInput", "countryItem", "fieldsContainer", "trigger", "triggerDefaultText"]
  static values = {
    selected: String
  }

  connect() {
    this.selectedValue = this.selectedValue || ""
    this.associationName = this.element.dataset.associationName
    this.modelName = this.element.dataset.modelName
    this.updateTriggerText()

    const radio = this.element.querySelector(`input[type="radio"][value="${this.selectedValue}"]`)
    if (radio) {
      radio.checked = true
    }
  }

  openModal() {
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    document.body.style.overflow = "hidden"

    // Focus search input
    setTimeout(() => {
      this.searchInputTarget.focus()
    }, 100)
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    document.body.style.overflow = ""
  }

  toggleCountry(event) {
    const selectedCountryCode = event.currentTarget.value;

    this.updateHiddenField(selectedCountryCode)

    console.log(selectedCountryCode)

    // Clear previously selected values and fields
    this.selectedValue = ""; // Reset the selected values array
    const fieldGroups = this.fieldsContainerTarget.querySelectorAll(`div[data-country-code]`);

    fieldGroups.forEach(fieldGroup => fieldGroup.remove()); // Remove all country fields

    // Add the newly selected country
    this.selectedValue = selectedCountryCode
    this.addCountryField(selectedCountryCode);

    this.updateTriggerText()
  }

  addCountryField(countryCode) {
    // Check if field already exists
    const existing = this.fieldsContainerTarget.querySelector(`[data-country-code="${countryCode}"]`)
    if (existing) return

    // Create a new nested field group
    const index = new Date().getTime() // Use timestamp as unique index
    const fieldGroup = document.createElement('div')
    fieldGroup.dataset.countryCode = countryCode

    // Create hidden fields for country entry
    fieldGroup.innerHTML = `
      <input type="hidden" name="${this.modelName}[${this.associationName}]" value="${countryCode}">
    `

    this.fieldsContainerTarget.appendChild(fieldGroup)
  }

  removeCountryField(countryCode) {
    const fieldGroup = this.fieldsContainerTarget.querySelector(`[data-country-code="${countryCode}"]`)
    if (fieldGroup) {
      // Check if this is a persisted record (has an ID field)
      const idField = fieldGroup.querySelector('input[name$="[id]"]')
      if (idField) {
        // Mark for destruction instead of removing
        const destroyField = document.createElement('input')
        destroyField.type = 'hidden'
        destroyField.name = idField.name.replace('[id]', '[_destroy]')
        destroyField.value = '1'
        fieldGroup.appendChild(destroyField)
      } else {
        // Remove the field group entirely if it's not persisted
        fieldGroup.remove()
      }
    }
  }

  search(event) {
    const query = event.target.value.toLowerCase()

    this.countryItemTargets.forEach(item => {
      const countryName = item.dataset.countryName.toLowerCase()
      if (countryName.includes(query)) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })
  }

  confirm(event) {
    event.preventDefault()
    this.closeModal()
  }

  updateTriggerText() {
    if (this.hasTriggerTarget) {
      const value = this.selectedValue
      if (!value || value === "null") {
        this.triggerTarget.textContent = this.triggerDefaultTextTarget.textContent
      } else {
        // Find the country name from the checked checkbox
        let countryName = "";
        const radio = this.element.querySelector(`input[type="radio"][value="${value}"]`)
        if (radio) {
          const item = radio.closest('[data-country-singleselect-target="countryItem"]')
          if (item && item.dataset.countryName) {
            countryName = item.dataset.countryName
          }
        }
        this.triggerTarget.textContent = countryName
      }
    }
  }

  updateHiddenField(value) {
    const hiddenInput = this.fieldsContainerTarget.querySelector('input[type="hidden"]');
    if (hiddenInput) {
      hiddenInput.value = value;
    }
  }

  // Close modal when clicking outside
  handleBackdropClick(event) {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }
}
